export default __webpack_public_path__ + "static/media/ar.64188f1f.svg";